import Vue from 'vue'
import store from '../store'
import i18n from '../../helpers/i18nHelpers'
import VueSweetAlert from 'vue-sweetalert'
import axios from 'axios'
import { firebaseAuth } from '../../helpers/firebaseHelpers'
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth'

Vue.use(VueSweetAlert)

const vueObj = new Vue()

const state = {
  isCheckingLogin: false,
  userPartner: null
}

const actions = {
  LOAD_USER_PARTNER_DETAIL: ({commit}, queryData) => {
    commit('SET_USER_PARTNER_DETAIL', null)
    commit('SET_IS_CHECKING_LOGIN', true)
    let url = `https://cors-anywhere.herokuapp.com/https://www.sansiri.com/family/api/booking/appointment?token=${queryData.token}&access_token=${queryData.access_token}`
    axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(resp => {
        const response = resp.data
        // console.log('axios response', resp)
        switch (response.code) {
          case '200':
            commit('SET_USER_PARTNER_DETAIL', response.data)
            const data = {
              key: 'token',
              value: queryData.token
            }
            commit('UPDATE_USER_PARTNER_DETAIL', data)
            store.dispatch('partner/ADD_USER_PARTNER', response.data)
            break
          case 'TOKEN_EXPIRED':
            commit('SET_IS_CHECKING_LOGIN', false)
            vueObj.$swal('Oops!', response.message, 'error')
            break
          case 'INVALID_TOKEN':
            commit('SET_IS_CHECKING_LOGIN', false)
            vueObj.$swal('Oops!', response.message, 'error')
            break
        }
      })
  },
  ADD_USER_PARTNER: ({commit}, submitData) => {
    const url = 'partners/sansiri'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          const email = response.email
          const password = response.password
          if (response.is_new_partner && response.is_new_user) {
            createUserWithEmailAndPassword(firebaseAuth, email, password)
              .then(user => {
                signInWithEmailAndPassword(firebaseAuth, email, password).then(user => {
                  const loginData = {
                    email: email,
                    social_name: 'email_password',
                    token: null
                  }
                  store.dispatch('auth/LOGIN', loginData)
                  commit('SET_IS_CHECKING_LOGIN', false)
                  // Alert user
                  vueObj.$swal({
                    type: 'success',
                    html: i18n.t('message.partner.message01') + '<br/>' +
                      '<h3>' + i18n.t('message.partner.message02') + '</h3>' +
                      '<div class="mb-4">' + i18n.t('message.partner.message03') + '</div>' +
                      '<div class="mb-4">' + i18n.t('message.partner.message04') + '</div>' +
                      '<label>' + i18n.t('message.login.email') + ':</label> ' + email + '<br>' +
                      '<label>' + i18n.t('message.login.password') + ':</label> ' + password
                  })
                }).catch(error => {
                  commit('SET_IS_CHECKING_LOGIN', false)
                  console.log('error login', error)
                })
              })
              .catch(error => {
                commit('SET_IS_CHECKING_LOGIN', false)
                console.log('error register', error)
              })
          } else {
            commit('SET_IS_CHECKING_LOGIN', false)
            let html = null
            if (response.is_new_partner) {
              html += i18n.t('message.partner.message01') + '<br/>' +
                '<h3>' + i18n.t('message.partner.message02') + '</h3>' +
                '<div class="mb-4">' + i18n.t('message.partner.message03') + '</div>'
            }

            if (!response.is_new_user) {
              if (response.social_name === 'email_password') {
                const loginData = {
                  email: email,
                  social_name: response.social_name,
                  token: null
                }
                store.dispatch('auth/LOGIN', loginData)
              } else {
                html += '<br>' + i18n.t('message.alert.already_registered') + ' ' + response.social_name
              }
            }

            if (html) {
              vueObj.$swal({
                type: 'success',
                html: html
              })
            }
          }
        }
      })
  },
  SEND_COMPLETE_BOOKING: ({commit}, submitData) => {
    const url = 'https://cors-anywhere.herokuapp.com/' + submitData.return_url
    axios.post(url,
      submitData,
      {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(resp => {
        const response = resp.data
        // console.log('complete response', response)
        if (response.status === 200) {
          const lang = submitData.lang
          window.location.href = `https://www.sansiri.com/family/${lang}/service/thankyou?token=${submitData.token}`
        }
      })
  }
}

const mutations = {
  SET_IS_CHECKING_LOGIN: (state, status) => {
    state.isCheckingLogin = status
  },
  SET_USER_PARTNER_DETAIL: (state, data) => {
    state.userPartner = data
  },
  UPDATE_USER_PARTNER_DETAIL: (state, data) => {
    state.userPartner[data.key] = data.value
  }
}

const getters = {
  getIsCheckingLogin: state => {
    return state.isCheckingLogin
  },
  getUserPartner: state => {
    return state.userPartner
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/partner.js